<template>
  <div class="text-gallery">
    <div class="text-gallery__labelled-control">
      <label class="text-gallery__control-label">
        Font
      </label>
      <font-selector
        :fonts="fonts"
        :selected-font="textState?.style.fontFamily ?? null"
        :disabled="textState === null"
        @font-selected="onFontSelected"
      />
    </div>
    <div class="text-gallery__labelled-control">
      <label class="text-gallery__control-label">
        Color
      </label>
      <colour-selector
        :selected-colour="textState?.style.color ?? null"
        :disabled="textState === null"
        @colour-selected="onColourSelected"
      />
    </div>
    <div class="text-gallery__labelled-control">
      <label class="text-gallery__control-label">
        Align
      </label>
      <alignment-selector
        :selected-alignment="textState?.style.textAlign ?? null"
        :disabled="textState === null"
        @alignment-selected="onAlignmentSelected"
      />
    </div>
    <div class="text-gallery__labelled-control">
      <label class="text-gallery__control-label">
        Style
      </label>
      <font-background-selector
        :selected-font-background-color="textState?.style.backgroundColor ?? null"
        :disabled="textState === null"
        @font-background-color-selected="onFontBackgroundColorSelected"
      />
    </div>
    <small-button
      class="text-gallery__add-text-button"
      text="Add text"
      :is-disabled="applicationStore.editTextState !== 'none'"
      @click="addText({ style: applicationStore.selectedText?.style })"
      v-show="projectStore.textStates.length > 0"
    >
      <plus-icon/>
    </small-button>
  </div>
</template>
<script setup lang="ts">
import { fonts } from '@/static/fonts'
import FontSelector from '@/components/text/FontSelector.vue'
import AlignmentSelector from '@/components/text/AlignmentSelector.vue'
import FontBackgroundSelector from '@/components/text/FontBackgroundSelector.vue'
import { TextAlign } from '@/types'
import SmallButton from '@/components/text/SmallButton.vue'
import PlusIcon from '@/assets/PlusIcon.svg'
import { useProjectStore } from '@/store/project-store'
import ColourSelector from '@/components/text/ColourSelector.vue'
import { useApplicationStore } from '@/store/application-store'
import useTextStates from '@/composables/UseTextStates'
import { computed } from 'vue'

const projectStore = useProjectStore()
const applicationStore = useApplicationStore()

const textState = computed(() => applicationStore.editTextState !== 'none' ? applicationStore.currentEditingText : applicationStore.selectedText)

const onFontSelected = (fontName: string) => {
  if (textState.value) {
    textState.value.style.fontFamily = fontName
  }
}

const onAlignmentSelected = (alignment: TextAlign) => {
  if (textState.value) {
    textState.value.style.textAlign = alignment
  }
}

const onFontBackgroundColorSelected = (backgroundColor: string) => {
  if (textState.value) {
    textState.value.style.backgroundColor = backgroundColor
  }
}

const onColourSelected = (colour: string) => {
  if (textState.value) {
    textState.value.style.color = colour
  }
}

const { addText } = useTextStates()

</script>
<style lang="scss">
.text-gallery {
  display: flex;
  flex-direction: column;
  gap: 32px;
  font-family: $font-medium;

  padding: 32px;

  &__labelled-control {
    display: flex;
    flex-direction: row;
  }

  &__control-label {
    width: 50px;
    height: 40px;
    line-height: 40px;
    text-align: left;
    font-size: 11px;
    color: $grey-50;
  }
  &__add-text-button {
    align-self: flex-start;
  }
}
</style>
